import XcolumnFunc from '@/pcomponents/common/xcolumn/xcolumn/xcolumn_func';

function SelectStuArea(props: any) {
  let myProps = {
    stu_info_arr: [],
    set_stu_info_arr: (inData: any) => { },
    ...props
  };
  let stu_info_arr = myProps.stu_info_arr;

  let select_stu_grade2_option_arr=XcolumnFunc.getSortByTableKey({'table':'user','key':'a_stu_grade2'});

  const go_remove_stu_by_idx=(inData:any)=>{
    let opt_obj={
      idx_num:0,
      ...inData
    };
    let idx_num=opt_obj.idx_num;
    let new_stu_info_arr:any=[];
    for(let i=0;i<stu_info_arr.length;i++){
      if(idx_num!=i){
        new_stu_info_arr.push(stu_info_arr[i]);
      }
    }
    myProps.set_stu_info_arr(new_stu_info_arr);
  };

  let wrap_div_style:any={display:"flex",gap:"10px",flexWrap:"wrap",padding:"10px"};
  let stu_tag_style:any={
    display:"inline-block",
    width:"110px",
    padding:"0px 5px",
    color:"#ffffff",
    backgroundColor:"#236d54",
    borderRadius:"5px",
    textAlign:"center",
    minHeight:"30px",
    lineHeight:"30px",
  };
  const get_stu_box_tags=()=>{
    let tags=stu_info_arr.map((item:any,idx:number)=>{
      let stu_grade_str="";
      for(let i=0;i<select_stu_grade2_option_arr.length;i++){
        let row_select_option=select_stu_grade2_option_arr[i];
        if(item["a_stu_grade"]==row_select_option["value"]){
          stu_grade_str=row_select_option["text"];
          break;
        }
      }
      let stu_total_code=item["a_stu_total_code"];
      return (
        <div key={idx} style={stu_tag_style}>
          {item["a_user_name"]} 
          <span className="ml-1" style={{color:"#84ffe6",fontSize:"12px"}}>{stu_total_code}</span>
          <span className="ml-1">{stu_grade_str}</span>
          <button className="btn-s btn-red ml-1" 
            onClick={()=>{
              go_remove_stu_by_idx({idx_num:idx});
            }} >X</button>
        </div>
      );
    });
    return tags;
  };

  return (
    <div>
      <div>학생선택 ({stu_info_arr.length}명) </div>
      <div style={wrap_div_style}>
        {get_stu_box_tags()}
      </div>
    </div>
  );
};
export default SelectStuArea;